var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center shadow-card p-3 width-300"},[_c('p',{staticClass:"mb-0 text-muted"},[_vm._v(_vm._s(_vm.title))]),(_vm.subTitle)?_c('p',{staticClass:"mb-0 text-muted"},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e(),_c('svg-icon',{staticClass:"fill-icon mt-2",attrs:{"name":"empty-file","size":"28"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }